import { DEFAULT_LOCALE } from '../variables';

const translatedObjOfDefaultLocale = translatedCities =>
  translatedCities.find(obj => obj.locale === DEFAULT_LOCALE);

export default translatedObjOfDefaultLocale;
